export const SERVICE_PAGE_NAME = 'service-page';
